import AbsComponent from "../AbsComponent";

export default class Equipments extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);
    }

    setting(_d, _isCompare='true', _parent, compareMode = false){
        
        $(_parent + ' .info-item').toggle(this.store.getState().isAllowed);
        if (!this.store.getState().isAllowed) {
            return;
        }


        _d = _d.data;
        let lang = $('html').attr('lang') || 'ko';
        let barwidth = compareMode? 60: 48;
        let subTempl = this.SubItems(_d, _isCompare, _parent, compareMode);

        let templ = $(`
        <div class="item-wrap">
            <div class="weapon-wrap">
            ${_d.hand?`
                <div class="icon">
                    <p class="item-img" data-tooltip="${_d.hand.tooltip_string}">
                        <img src="${_d.hand.detail.item.icon}" alt="${_d.hand.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.hand.tooltip_string}">
                    </p>
                    <div class="quality">
                        <span class="bar" style="width:${barwidth*_d.hand.detail.durability/_d.hand.detail.item.max_durability}px"></span>
                        <span class="text">${_d.hand.detail.durability}/${_d.hand.detail.item.max_durability}</span>
                    </div>
                </div>
                <div class="item-name">
                    <span class="grade_${_d.hand.detail.item.grade}">${_d.hand.detail.item.name}</span>
                </div>
            `:`
                <div class="icon">
                    <p class="item-img"></p>
                    <div class="quality">
                        <span class="bar" style="width:0px"></span>
                        <span class="text">0 / 0</span>
                    </div>
                </div>
                <div class="item-name"><span class="grade_none">${this.l10n.weapon}</span></div>
            `}

                <div class="enchant">
                    <div class="enchant-usable1">
                    ${_d.hand?.detail?.item.enchant_gem_slot_usable1?`
                        ${_d.hand.detail.added_enchant_gems[0]?`
                        <span class="item-img" data-tooltip="${_d.hand.detail.added_enchant_gems[0].id}.${_d.hand.detail.added_enchant_gems[0].level}.0.1.0.0.0.0.0.0.0">
                        <img src="${_d.hand.detail.added_enchant_gems[0].icon}" alt="${_d.hand.detail.added_enchant_gems[0].name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.hand.detail.added_enchant_gems[0].id}.${_d.hand.detail.added_enchant_gems[0].level}.0.1.0.0.0.0.0.0.0">
                        `:`<span class="item-img">`}
                        </span>
                    `:``}

                    ${_d.hand?.detail?.item.enchant_gem_slot_usable2?`
                        ${_d.hand.detail.added_enchant_gems[1]?`
                        <span class="item-img" data-tooltip="${_d.hand.detail.added_enchant_gems[1].id}.${_d.hand.detail.added_enchant_gems[1].level}.0.1.0.0.0.0.0.0.0">
                        <img src="${_d.hand.detail.added_enchant_gems[1].icon}" alt="${_d.hand.detail.added_enchant_gems[1].name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.hand.detail.added_enchant_gems[1].id}.${_d.hand.detail.added_enchant_gems[1].level}.0.1.0.0.0.0.0.0.0">
                        `:`<span class="item-img">`}
                        </span>
                    `:``}
                    </div>

                    ${_d.hand?.detail?.added_gems.length?`
                    <div class="enchant-usable2">
                        ${_d.hand?.detail?.added_gems?.map(it=>`
                        ${it.name?`
                        <span class="item-img" data-tooltip="${it.id}.${it.level}.0.1.0.0.0.0.0.0.0">
                        <img src="${it.icon_transparent}" alt="${it.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${it.id}.${it.level}.0.1.0.0.0.0.0.0.0">
                        `:`<span class="item-img">`}
                        </span>
                        `).join('')}
                    </div>
                    `:``}
                </div>
            </div>


            <!-- 악세서리 정보 -->
            <div class="accessory-wrap">
                <div class="ring">
                ${_d.finger_left?`
                    <div class="item-img" data-tooltip="${_d.finger_left.tooltip_string}"><img src="${_d.finger_left.detail.item.icon}" alt="${_d.finger_left.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.finger_left.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.finger_left.detail.item.grade}">${_d.finger_left.detail.item.name}</span></div>
                `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.ring}</span></div>
                `}
                </div>

                <div class="earring">
                ${_d.ear_left?`
                    <div class="item-img" data-tooltip="${_d.ear_left.tooltip_string}"><img src="${_d.ear_left.detail.item.icon}" alt="${_d.ear_left.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.ear_left.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.ear_left.detail.item.grade}">${_d.ear_left.detail.item.name}</span></div>
                `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.earring}</span></div>
                `}
                </div>
                
                <div class="necklace">
                ${_d.neck?`
                    <div class="item-img" data-tooltip="${_d.neck.tooltip_string}"><img src="${_d.neck.detail.item.icon}" alt="${_d.neck.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.neck.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.neck.detail.item.grade}">${_d.neck.detail.item.name}</span></div>
                `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.necklace}</span></div>
                `}
                </div>

                <div class="bracelet">
                ${_d.bracelet?`
                    <div class="item-img" data-tooltip="${_d.bracelet.tooltip_string}"><img src="${_d.bracelet.detail.item.icon}" alt="${_d.bracelet.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.bracelet.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.bracelet.detail.item.grade}">${_d.bracelet.detail.item.name}</span></div>
                `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.bracelet}</span></div>
                `}
                </div>

                <div class="belt">
	            ${_d.belt?`
                    <div class="item-img" data-tooltip="${_d.belt.tooltip_string}"><img src="${_d.belt.detail.item.icon}" alt="${_d.belt.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.belt.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.belt.detail.item.grade}">${_d.belt.detail.item.name}</span></div>
	            `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.belt}</span></div>
	            `}
                </div>

                <div class="gloves">
	            ${_d.gloves?`
                    <div class="item-img" data-tooltip="${_d.gloves.tooltip_string}"><img src="${_d.gloves.detail.item.icon}" alt="${_d.gloves.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.gloves.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.gloves.detail.item.grade}">${_d.gloves.detail.item.name}</span></div>
	            `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.gloves}</span></div>
	            `}
                </div>

                <div class="soul">
	            ${_d.soul?`
                    <div class="item-img" data-tooltip="${_d.soul.tooltip_string}"><img src="${_d.soul.detail.item.icon}" alt="${_d.soul.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.soul.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.soul.detail.item.grade}">${_d.soul.detail.item.name}</span></div>
	            `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.soul}</span></div>
	            `}
                </div>

                <div class="soul-2">
	            ${_d.soul_2?`
                    <div class="item-img" data-tooltip="${_d.soul_2.tooltip_string}"><img src="${_d.soul_2.detail.item.icon}" alt="${_d.soul_2.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.soul_2.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.soul_2.detail.item.grade}">${_d.soul_2.detail.item.name}</span></div>
	            `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.soul2}</span></div>
	            `}
                </div>

                <div class="guard">
	            ${_d.pet?`
                    <div class="item-img" data-tooltip="${_d.pet.tooltip_string}"><img src="${_d.pet.detail.item.icon}" alt="${_d.pet.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.pet.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.pet.detail.item.grade}">${_d.pet.detail.item.name}</span></div>
	            `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.guard}</span></div>
	            `}
                </div>

                <div class="nova">
	            ${_d.nova?`
                    <div class="item-img" data-tooltip="${_d.nova.tooltip_string}"><img src="${_d.nova.detail.item.icon}" alt="${_d.nova.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.nova.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.nova.detail.item.grade}">${_d.nova.detail.item.name}</span></div>
	            `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.nova}</span></div>
	            `}
                </div>

                <div class="singongpae">
	            ${_d.soul_badge?`
                    <div class="item-img" data-tooltip="${_d.soul_badge.tooltip_string}"><img src="${_d.soul_badge.detail.item.icon}" alt="${_d.soul_badge.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.soul_badge.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.soul_badge.detail.item.grade}">${_d.soul_badge.detail.item.name}</span></div>
	            `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.singongpae}</span></div>
	            `}
                </div>

                <div class="rune">
                ${_d.swift_badge?`
                    <div class="item-img" data-tooltip="${_d.swift_badge.tooltip_string}"><img src="${_d.swift_badge.detail.item.icon}" alt="${_d.swift_badge.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.swift_badge.tooltip_string}"></div>
                    <div class="item-name"><span class="grade_${_d.swift_badge.detail.item.grade}">${_d.swift_badge.detail.item.name}</span></div>
                `:`
                    <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.rune}</span></div>
                `}
                </div>
            </div>

            ${!compareMode? subTempl: ``}
        </div>`);

        templ.find('.item-img').on('click', e => {
            let data = e.currentTarget.dataset?.tooltip;
            if (e.shiftKey && data) {
                location.href = 'nc://bns.Common/ItemPreview?item=' + data;
            }
        })


        $(_parent + ' .info-item').empty().append(templ);

        if (compareMode) {
            $(_parent + ' .info-item.subitem').remove();
            $(_parent + ' .gem-wrap').after(`<section class="info-item subitem"><div class="item-wrap">${subTempl}</div></section>`);
        }

    }




    SubItems(_d, _isCompare, _parent, compareMode){
        let lang = $('html').attr('lang') || 'ko';
        return `
        ${(lang==='ko')?`
        <!-- new 정보 -->
        <div class="newItem-wrap">
            <div class="weapon">
            ${_d.hand_appearance?`
                <div class="item-img" data-tooltip="${_d.hand_appearance.tooltip_string}"><img src="${_d.hand_appearance.detail.item.icon}" alt="${_d.hand_appearance.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.hand_appearance.tooltip_string}"></div>
                <div class="item-name"><span class="grade_${_d.hand_appearance.detail.item.grade}">${_d.hand_appearance.detail.item.name}</span></div>
            `:`
                <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.illusionWeapon}</span></div>
            `}
            </div>

            <div class="guard">
            ${_d.pet_1_appearance?`
                <div class="item-img" data-tooltip="${_d.pet_1_appearance.tooltip_string}"><img src="${_d.pet_1_appearance.detail.item.icon}" alt="${_d.pet_1_appearance.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.pet_1_appearance.tooltip_string}"></div>
                <div class="item-name"><span class="grade_${_d.pet_1_appearance.detail.item.grade}">${_d.pet_1_appearance.detail.item.name}</span></div>
            `:`
                <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.petAura}</span></div>
            `}
            </div>
        </div>
        `:``}


        <!-- 의상 정보 -->
        <div class="accessory-wrap" ${compareMode?'style="margin-top: 0px;"':''}>
            <div class="clothes">
            ${_d.body?`
                <div class="item-img" data-tooltip="${_d.body.tooltip_string}"><img src="${_d.body.detail.item.icon}" alt="${_d.body.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.body.tooltip_string}"></div>
                <div class="item-name"><span class="grade_${_d.body.detail.item.grade}">${_d.body.detail.item.name}</span></div>
            `:`
                <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.clothes}</span></div>
            `}
            </div>

            <div class="clothesDecoration">
            ${_d.body_accessory?`
                <div class="item-img" data-tooltip="${_d.body_accessory.tooltip_string}"><img src="${_d.body_accessory.detail.item.icon}" alt="${_d.body_accessory.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.body_accessory.tooltip_string}"></div>
                <div class="item-name"><span class="grade_${_d.body_accessory.detail.item.grade}">${_d.body_accessory.detail.item.name}</span></div>
            `:`
                <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.clothesDecoration}</span></div>
            `}
            </div>

            <div class="tire">
            ${_d.head?`
                <div class="item-img" data-tooltip="${_d.head.tooltip_string}"><img src="${_d.head.detail.item.icon}" alt="${_d.head.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.head.tooltip_string}"></div>
                <div class="item-name"><span class="grade_${_d.head.detail.item.grade}">${_d.head.detail.item.name}</span></div>
            `:`
                <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.tire}</span></div>
            `}
            </div>

            <div class="faceDecoration">
            ${_d.eye?`
                <div class="item-img" data-tooltip="${_d.eye.tooltip_string}"><img src="${_d.eye.detail.item.icon}" alt="${_d.eye.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.eye.tooltip_string}"></div>
                <div class="item-name"><span class="grade_${_d.eye.detail.item.grade}">${_d.eye.detail.item.name}</span></div>
            `:`
                <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.faceDecoration}</span></div>
            `}
            </div>

            ${(lang==='ko')?`
            <div class="illusionDeco">
            ${_d.normal_state_appearance?`
                <div class="item-img" data-tooltip="${_d.normal_state_appearance.tooltip_string}"><img src="${_d.normal_state_appearance.detail.item.icon}" alt="${_d.normal_state_appearance.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.normal_state_appearance.tooltip_string}"></div>
                <div class="item-name"><span class="grade_${_d.normal_state_appearance.detail.item.grade}">${_d.normal_state_appearance.detail.item.name}</span></div>
            `:`
                <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.illusionDeco}</span></div>
            `}
            </div>
            <div class="idleState">
            ${_d.idle_state_appearance ?`
                <div class="item-img" data-tooltip="${_d.idle_state_appearance.tooltip_string}"><img src="${_d.idle_state_appearance.detail.item.icon}" alt="${_d.idle_state_appearance.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.idle_state_appearance.tooltip_string}"></div>
                <div class="item-name"><span class="grade_${_d.idle_state_appearance.detail.item.grade}">${_d.idle_state_appearance.detail.item.name}</span></div>
            `:`
                <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.idleState}</span></div>
            `}
            </div>
            <div class="vehicle">
            ${_d.vehicle ?`
                <div class="item-img" data-tooltip="${_d.vehicle.tooltip_string}"><img src="${_d.vehicle.detail.item.icon}" alt="${_d.vehicle.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.vehicle.tooltip_string}"></div>
                <div class="item-name"><span class="grade_${_d.vehicle.detail.item.grade}">${_d.vehicle.detail.item.name}</span></div>
            `:`
                <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.vehicle}</span></div>
            `}
            </div>
            <div class="namePlate">
            ${_d.name_plate_appearance ?`
                <div class="item-img" data-tooltip="${_d.name_plate_appearance.tooltip_string}"><img src="${_d.name_plate_appearance.detail.item.icon}" alt="${_d.name_plate_appearance.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.name_plate_appearance.tooltip_string}"></div>
                <div class="item-name"><span class="grade_${_d.name_plate_appearance.detail.item.grade}">${_d.name_plate_appearance.detail.item.name}</span></div>
            `:`
                <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.namePlate}</span></div>
            `}
            </div>
            <div class="speechBubble">
            ${_d.speech_bubble_appearance ?`
                <div class="item-img" data-tooltip="${_d.speech_bubble_appearance.tooltip_string}"><img src="${_d.speech_bubble_appearance.detail.item.icon}" alt="${_d.speech_bubble_appearance.detail.item.name}" title="nc://bns.CharInfo/ItemTooltip?compare=${_isCompare}&item=${_d.speech_bubble_appearance.tooltip_string}"></div>
                <div class="item-name"><span class="grade_${_d.speech_bubble_appearance.detail.item.grade}">${_d.speech_bubble_appearance.detail.item.name}</span></div>
            `:`
                <div class="item-img"></div><div class="item-name"><span class="grade_none">${this.l10n.speechBubble}</span></div>
            `}
            </div>
            `:``}
        </div>`;
    }








} // end of class